export const mailEllipsisAriaLabelText = "_Ra";
export default {mailEllipsisAriaLabelText};